import { PushPin, PushPinOutlined } from '@mui/icons-material';
import { ButtonIcon } from 'components/general';
import { formatTranslation } from 'intl';
import { DocumentationTranslationKeys } from 'intl/keys';
import { MouseEventHandler, ReactElement } from 'react';
import { useIntl } from 'react-intl';

const PROGRESS_PANEL_PIN_TITLE_KEY = {
  pinned: DocumentationTranslationKeys.progressPanelUnpin,
  unpinned: DocumentationTranslationKeys.progressPanelPin,
} as const;

export function DocumentationProgressPinButton({
  onClick,
  pinned,
}: {
  pinned: boolean;
  onClick: MouseEventHandler;
}): ReactElement {
  const intl = useIntl();

  const title = formatTranslation(
    intl,
    PROGRESS_PANEL_PIN_TITLE_KEY[pinned ? 'pinned' : 'unpinned']
  );

  return (
    <ButtonIcon title={title} onClick={onClick} size='small'>
      {pinned ? <PushPin fontSize='small' /> : <PushPinOutlined fontSize='small' />}
    </ButtonIcon>
  );
}
